const emptyIfNullish = (value) => {
    if (value == null || value === "null") {
        return "";
    }
    return String(value).trim();
};

const joinLastFirst = (lastName, firstName) => {
    const last = emptyIfNullish(lastName);
    const first = emptyIfNullish(firstName);
    return [last, first].filter((part) => part.length > 0).join(" ");
};

const parseSignatureCreationTime = (value) => {
    if (typeof value === "number" && !Number.isNaN(value)) {
        return value;
    }
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return value.getTime();
    }
    const isoWithOffsetMinutes = String(value).replace(/([+-]\d{2})$/, "$1:00");
    const t = Date.parse(isoWithOffsetMinutes);
    return Number.isNaN(t) ? 0 : t;
};

export const getLastSignatureDisplayName = (tx) => {
    const signatures = tx?.signatures;
    if (!Array.isArray(signatures) || signatures.length === 0) {
        return "";
    }
    const last = [...signatures]
        .filter(Boolean)
        .sort(
            (a, b) => parseSignatureCreationTime(b.creationDateTime) - parseSignatureCreationTime(a.creationDateTime),
        )[0];
    if (!last) {
        return "";
    }
    const full = emptyIfNullish(last?.userFullName);
    if (full) {
        return full;
    }
    return joinLastFirst(last?.userLastName, last?.userFirstName);
};

export const getTransactionPreparedByDisplayName = (tx) =>
    joinLastFirst(tx?.userCreatorLastName, tx?.userCreatorFirstName);

export const getLastUpdateUserName = (tx) => {
    const status = tx?.idTransactionStatus;
    const data = tx?.data || {};

    if (status === "CANCELLED") {
        const cancelled = emptyIfNullish(data.cancelledUser);
        if (cancelled) {
            return cancelled;
        }
    }

    if (status === "FINISHED" || status === "FAILED") {
        const liberator = emptyIfNullish(data.liberatorUser);
        if (liberator) {
            return liberator;
        }
    }

    const fromSignature = getLastSignatureDisplayName(tx);
    if (fromSignature) {
        return fromSignature;
    }
    return getTransactionPreparedByDisplayName(tx);
};
